<div class="sub-header">
  <div class="menu-container">
    <div class="menu-item" *ngFor="let item of menuItems" (click)="toggleSubmenu(item, $event)">
      <div class="menu-title">
        <a>{{ item.label }}</a>
      </div>
      <div *ngIf="item.open" class="submenu">
        <div *ngFor="let subItem of item.subItems" (click)="toggleSubmenu(subItem, $event)">
          <a>{{ subItem.label }}</a>
        </div>
      </div>
    </div>
  </div>
  <div class="subtitulo-container">
    <h3 class="menu-subtitle">{{ sub_titulo }}</h3>
  </div>
</div>